import {NgModule} from '@angular/core'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {JobRequestDetailPageComponent} from './job-request-detail-page/job-request-detail-page.component'
import {JobRequestContactPageComponent} from './job-request-contact-page/job-request-contact-page.component'
import {JobRequestExecutionDetailsPageComponent} from './job-request-execution-details-page/job-request-execution-details-page.component'
import {JobRequestSummaryPageComponent} from './job-request-summary-page/job-request-summary-page.component'
import {JobRequestSuccessPageComponent} from './job-request-success-page/job-request-success-page.component'
import {TranslocoModule} from '@ngneat/transloco'
import {ReactiveFormsModule} from '@angular/forms'
import {PipesModule} from '../../../shared/pipes/pipes.module'
import {DirectivesModule} from '../../../shared/directives/directives.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {JobRequestPageComponent} from './job-request-page.component'
import {JobRequestRoutingModule} from './job-request-routing.module'
import {InstallLampsStaticFormComponent} from './job-request-detail-page/job-request-static-forms/install-lamps/install-lamps-static-form.component'
import {NumberInputModule} from '../../../craft/forms/number-input/number-input.module'
import {DynamicFormModule} from '../../../shared/components/dynamic-form/dynamic-form.module'
import {FilesModule} from '../../../craft/files/files.module'
import {JobRequestFooterComponent} from './job-request-footer/job-request-footer.component'
import {JobRequestService} from './job-request.service'
import {StepByStepModule} from '../../../craft/step-by-step/step-by-step.module'
import {ProcessNavbarModule} from '../../../shared/components/process-navbar/process-navbar.module'
import {CatDoorInstallationStaticFormComponent} from './job-request-detail-page/job-request-static-forms/cat-door-installation/cat-door-installation-static-form.component'
import {PriceEstimationModule} from '../../../craft/price-estimation/price-estimation.module'
import {JobRequestSummaryCardComponent} from './job-request-summary-card/job-request-summary-card.component'
import {JobRequestDynamicFormComponent} from './job-request-detail-page/job-request-dynamic-form/job-request-dynamic-form.component'
import {BrandingModule} from '../../../shared/components/branding/branding.module'
import {JobRequestFragmentSummaryCardComponent} from './job-request-summary-page/job-request-fragment-summary-card/job-request-fragment-summary-card.component'
import {CheckboxModule} from '../../../craft/forms/checkbox/checkbox.module'
import {RadioModule} from '../../../craft/forms/radio/radio.module'
import {RenewableEnergyConsultingFormComponent} from './job-request-detail-page/job-request-static-forms/renewable-energy-consulting/renewable-energy-consulting-form.component'
import {BroadcastActivateEventsModule} from '../../../shared/directives/router-outlet/broadcast-activate-events.module'
import {SupportBoxModule} from '../../../craft/support/support-box/support-box.module'
import {SupportPortraitComponent} from '../../../craft/support/support-portrait/support-portrait.component'
import {ChipComponent} from '../../../craft/chip/chip.component'
import {JobRequestIntentionComponent} from './job-request-intention/job-request-intention.component'
import {FormsModule} from '../../../craft/forms/forms.module'
import {ButtonModule} from '../../../craft/button/button.module'
import {JobRequestClientExpectationPageComponent} from './job-request-client-expectation-page/job-request-client-expectation-page.component'
import {DynamicIconModule} from '../../../craft/dynamic-icon/dynamic-icon.module'
import {InfoBoxModule} from '../../../craft/info-box/info-box.module'
import {CardsModule} from '../../../craft/cards/cards.module'
import {ErrorBannerComponent} from '../../../shared/components/error-banner/error-banner.component'
import {WhyBuildigoItemComponent} from '../../../shared/components/why-buildigo-item/why-buildigo-item.component'
import {OptionCountComponent} from './job-request-detail-page/static-form/option-count/option-count.component'
import {StaticFormComponent} from './job-request-detail-page/static-form/static-form.component'
import {LawnMaintenanceStaticFormComponent} from './job-request-detail-page/job-request-static-forms/lawn-maintenance/lawn-maintenance-static-form.component'
import {LawnMowingStaticFormComponent} from './job-request-detail-page/job-request-static-forms/lawn-mowing/lawn-mowing-static-form.component'
import {TreeCuttingStaticFormComponent} from './job-request-detail-page/job-request-static-forms/tree-cutting/tree-cutting-static-form.component'
import {HedgeTrimmingStaticFormComponent} from './job-request-detail-page/job-request-static-forms/hedge-trimming/hedge-trimming-static-form.component'
import {SelectModule} from '../../../craft/forms/select/select.module'
import {BoilerDescalingStaticFormComponent} from './job-request-detail-page/job-request-static-forms/boiler-descaling/boiler-descaling-static-form.component'
import {JobRequestPageMetadataService} from './job-request-page-metadata.service'
import {LayingParquetStaticFormComponent} from './job-request-detail-page/job-request-static-forms/laying-parquet/laying-parquet-static-form.component'
import {ParquetMaintenanceStaticFormComponent} from './job-request-detail-page/job-request-static-forms/parquet-maintenance/parquet-maintenance-static-form.component'
import {SolarInstallationStaticFormComponent} from './job-request-detail-page/job-request-static-forms/solar-installation/solar-installation-static-form.component'
import {AsFormArrayPipe} from '../../../shared/pipes/as-form-array.pipe'
import {LoadableModule} from '../../../core/lazy-loading/loadable.module'
import {ProgressStepperComponent} from '../../../craft/progress-steps/progress-stepper.component'
import {FullLocationPipe} from '../../../shared/pipes/full-location.pipe'
import {JobAgentSupportBoxComponent} from '../../../shared/components/domain/job/job-agent-support-box/job-agent-support-box.component'

@NgModule({
  declarations: [
    JobRequestDetailPageComponent,
    JobRequestContactPageComponent,
    JobRequestExecutionDetailsPageComponent,
    JobRequestSummaryPageComponent,
    JobRequestSuccessPageComponent,
    JobRequestPageComponent,
    InstallLampsStaticFormComponent,
    JobRequestFooterComponent,
    CatDoorInstallationStaticFormComponent,
    JobRequestSummaryCardComponent,
    JobRequestDynamicFormComponent,
    JobRequestFragmentSummaryCardComponent,
    RenewableEnergyConsultingFormComponent,
    JobRequestIntentionComponent,
    JobRequestClientExpectationPageComponent,
    StaticFormComponent,
    OptionCountComponent,
    LawnMaintenanceStaticFormComponent,
    LawnMowingStaticFormComponent,
    TreeCuttingStaticFormComponent,
    HedgeTrimmingStaticFormComponent,
    BoilerDescalingStaticFormComponent,
    LayingParquetStaticFormComponent,
    ParquetMaintenanceStaticFormComponent,
    SolarInstallationStaticFormComponent,
  ],
  imports: [
    CommonModule,
    JobRequestRoutingModule,
    TranslocoModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    FontAwesomeModule,
    DynamicFormModule,
    NumberInputModule,
    FilesModule,
    StepByStepModule,
    ProcessNavbarModule,
    PriceEstimationModule,
    BrandingModule,
    InfoBoxModule,
    SupportBoxModule,
    CheckboxModule,
    RadioModule,
    BroadcastActivateEventsModule,
    SupportPortraitComponent,
    ChipComponent,
    FormsModule,
    ButtonModule,
    DynamicIconModule,
    NgOptimizedImage,
    CardsModule,
    ErrorBannerComponent,
    WhyBuildigoItemComponent,
    SelectModule,
    AsFormArrayPipe,
    LoadableModule,
    LoadableModule.forRoot({
      moduleConfigs: [
        {
          name: 'confetti',
          load: () => import('../../../shared/components/confetti/confetti.module').then(m => m.ConfettiModule),
        },
      ],
    }),
    ProgressStepperComponent,
    FullLocationPipe,
    JobAgentSupportBoxComponent,
  ],
  providers: [JobRequestService, JobRequestPageMetadataService],
})
export class JobRequestModule {}
